import Model from "./base/model";

class RequestSimulation extends Model {
  resourceName() {
    return "request_simulations";
  }

  fields() {
    return {
      table: "",
      type: "",
      transporter: "",
      weight_shipping_value: "",
      rates_value: "",
      total_value: "",
      lead_time: "",
      business_days: "",
      selected: "",
    };
  }

  async deleteFile(id){
    return this.request(
      `${this.resourceName()}/files/${id}` ,
      "DELETE",
      {}
    );
  }

  async deleteFilePdf(id){
    return this.request(
      `${this.resourceName()}/files_pdf/${id}` ,
      "DELETE",
      {}
    );
  }

  async getByHash(hash,params) {
    return this.request(
      this.resourceName()+"/get_by_hash/"+hash,
      "GET",
      params
    )
  }

}

export default new RequestSimulation();
